import React from 'react';
import PropTypes from 'prop-types';

import DogSearchingSvg from 'dpl/common/components/DogSearching';

export default function EmptyResults({ locationQuery }) {
  return (
    <div className="ShelterEmptyResults tc flex items-center mt8">
      <div>
        <div className="w11 center">
          <DogSearchingSvg />
        </div>
        <p className="f5 f6-lg">
          No results found {locationQuery ? `near ${locationQuery}` : 'nearby'}
        </p>
        <p className="mb6 silver">
          We&apos;re still gathering shelters and rescues in your area. At Good
          Dog we&apos;re experts at helping people find the dog of their dreams
          from good shelters and rescues. We&apos;d love to answer any questions
          you have.
        </p>
      </div>
    </div>
  );
}

EmptyResults.propTypes = {
  locationQuery: PropTypes.string
};

EmptyResults.defaultProps = {
  locationQuery: null
};
